import ImageLoader from 'components/ImageLoader'
import getLinkToDetail from 'helpers/getLinkToDetail'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {useHistory} from 'react-router'
import {Link} from 'react-router-dom'
import {APP_NAME} from '../../../envs/_current/config'
import {paths} from "../../MainPage/contains";
import {GiIronCross} from "react-icons/gi";
import {RiMessage3Line} from "react-icons/ri";
import {renderIfElse} from "../../Shared";
import {DoubleValueItem} from "../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {formatSimplifyDate} from "../../../helpers/dateUtils";

function ArticleItem({
                         auth,
                         title,
                         subTitle = `${APP_NAME}`,
                         categories = [],
                         keywords = [],
                         image,
                         created,
                         description,
                         url,
                         auth_avatar,
                         auth_name,
                         total_comments,
                     }) {
    const history = useHistory()
    const t = useTranslate()
    const getUrl = (category) => {
        const {id, language, alt_idname} = category
        const url = paths.categoryPath
            .replace(':category', id)

        return language ? `${url}` : url
    }

    return (
        <div className="py-2 flex flex-col gap-1 custom-render-border">
            <div className="flex gap-1 111-222-333">
                <div className="flex flex-col flex-1 mb-1">
                    <Link
                        className="font-bold text-sm max-lines-2 no-underline leading-tight tracking-wide"
                        to={{pathname: url}}>
                        {title}
                    </Link>
                    <DoubleValueItem
                        labelFirst="post at"
                        valueFirst={formatSimplifyDate(created, 'fullTime')}
                        labelSecond="send by"
                        valueSecond={
                            <a href={getLinkToDetail(auth)}
                               className="font-semibold text-primary-500 truncate no-underline">
                                {auth_name}
                            </a>
                        }
                        className="text-2xs"
                    />
                    <span className="text-xs text-color-500 italic max-lines-1">
                        {description}
                    </span>
                </div>
                {image && (
                    <ImageLoader
                        style={{
                            width: '4rem',
                            height: '4rem',
                            objectFit: 'cover',
                            borderRadius: 5,
                        }}
                        alt={title}
                        src={image}
                    />
                )}
            </div>
            <div className="flex items-end justify-between gap-1 leading-tight">
                {renderIfElse(
                    total_comments > 0,
                    <div onClick={() => {history.push(url)}} className="flex items-center gap-1 text-color-500">
                        <RiMessage3Line size={13}/>
                        <span className="font-bold text-xs text-color-100 leading-3">
                            {total_comments}
                        </span>
                    </div>,
                    <div/>
                )}
            </div>
            {categories?.length > 0 && (
                <div className="flex flex-wrap gap-x-2 hidden lg:flex">
                    {categories.map((item) => (
                        <Link
                            key={item.id}
                            to={getUrl(item)}
                            className="flex items-center text-primary italic font-medium text-xs">
                            <GiIronCross size={8} className="mr-2"/>
                            {item.name}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    )
}

export default ArticleItem
